"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = require("vue");
var _ColumnSettingPopover = _interopRequireDefault(require("./ColumnSettingPopover"));
var _BasisTable = _interopRequireDefault(require("@ys/micro-components/BasisTable"));
var _default = exports.default = {
  name: 'BasisTableLayout',
  // 集成搜索、表格展示、分页功能的业务布局组件
  components: {
    ColumnSettingPopover: _ColumnSettingPopover.default
  },
  provide() {
    return {
      tableWidth: (0, _vue.computed)(() => this.tableWidth)
    };
  },
  props: {
    ..._BasisTable.default.props,
    // 自定义属性 - v-model绑定的数据
    value: {
      type: Array,
      default: undefined
    },
    // 自定义属性 - 表格id
    tableId: {
      type: String,
      default: () => _.uniqueId('basis-table-layout-')
    },
    // 自定义属性 - 布局高度，需要带单位。如果scroll没有传值时可通过设置height的值来确定整个布局高度。否则可能出现表格高度无法撑满剩余屏幕的情况。
    height: {
      type: String,
      default: '100%'
    },
    // 设置横向或纵向滚动，也可用于指定滚动区域的宽和高，建议为 x 设置一个数字，如果要设置为 true，需要配合样式 .ant-table td { white-space: nowrap; }
    scroll: {
      type: Object,
      default: () => {
        return {}; // 如果传入 null 则不显示滚动条
      }
    },
    // 是否展示外边框和列边框
    bordered: {
      type: Boolean,
      default: true
    },
    // 是否显示分页 false - 否；true - 是 对象 - 自定义分页效果
    pagination: {
      type: [Boolean, Object],
      default: true
    },
    // 表格列的配置描述 https://www.antdv.com/components/table-cn/#Column
    columns: {
      type: Array,
      default: undefined
    },
    // 自定义属性 - 数据源。如果传递了该值，则使用该值，否则直接通过组件内部方法获取数据
    dataSource: {
      type: Array,
      default: undefined
    },
    // 自定义属性 - 工具栏的样式
    toolbarStyle: {
      type: Object,
      default: () => {}
    },
    // 自定义属性 - body内边距
    bodyPadding: {
      type: Number,
      default: 0
    },
    // 自定义属性 - 获取数据的方法
    method: {
      type: Function,
      default: undefined // 通过api配置的方法，如 getDataList
    },
    // 自定义属性 - 获取数据接口参数
    // 当使用内置的搜索表单时，该属性表示需要额外添加的参数，会被搜索表单组件中相同名称的值覆盖
    params: {
      type: Object,
      default: () => {}
    },
    // 自定义属性 - 在数据渲染前对接口返回的数据进行格式转换
    transformDataSource: {
      type: Function,
      default: undefined
      // default: (data) => {
      // 在这里对数据进行转换
      // data.forEach((item) => (item.tradeTime = 222))
      // }
    },
    // 自定义属性 - 是否需要立即执行请求。设置为false，可通过手动触发请求
    immediate: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - 是否可选择
    selectable: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 骨架屏设置段落占位图的行数
    skeletonRows: {
      type: Number,
      default: 5
    },
    // 搜索表单的props属性
    searchFormProps: {
      type: Object,
      default: () => {}
    },
    // 搜索表单的Form.Item配置，如果配置了searchFormProps.items，则该属性不生效。
    // 该属性用于在不需要配置其他props时快捷配置searchFormProps.items
    searchFormItems: {
      type: Array,
      default: undefined
    },
    // 自定义属性-是否显示刷新、列设置等工具按钮
    showToolBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rawData: undefined,
      searchParams: {},
      // 搜索表单组件返回参数
      targetScroll: {},
      targetLoading: false,
      targetColumns: [],
      // 最终传给<BasisTable></BasisTable>组件的columns配置
      targetDataSource: [],
      targetPagination: false,
      defaultPagination: {
        current: 1,
        defaultPageSize: 20,
        pageSize: 20,
        pageSizeOptions: ['20', '50', '100', '200'],
        onShowSizeChange: this.handlePageChange,
        onChange: this.handlePageChange,
        showSizeChanger: true,
        showQuickJumper: true,
        showLessItems: true,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      selectedRowKeys: [],
      sorterCache: {},
      // 排序操作的本地缓存，用于判断是否为服务端排序
      sorterParams: {},
      // 排序参数，合并到params中进行入参
      tableWidth: 1920
    };
  },
  computed: {
    // 最终提交给接口使用的参数
    targetParams() {
      const {
        pagination,
        targetPagination,
        params,
        searchParams,
        sorterParams
      } = this;

      // 自动添加分页参数
      const pageParams = {};
      if (pagination) {
        pageParams.pageNo = targetPagination.current;
        pageParams.pageSize = targetPagination.pageSize;
      }
      return _.merge({}, params, searchParams, sorterParams, pageParams);
    },
    // 用于搜索的列表项
    columnsFormItems() {
      const {
        columns
      } = this;
      // isSearch为true，或 isSearch为undefined且searchProps有值的column都作为搜索表单项
      const arr = _.cloneDeep(columns).filter(column => {
        if (typeof column.isSearch === 'function') return column.isSearch() === true;
        return column.isSearch === true || column.isSearch === undefined && column.searchProps;
      });
      return arr.map(item => {
        const {
          title,
          dataIndex,
          searchProps
        } = item;
        return _.merge({
          title,
          dataIndex
        }, searchProps);
      });
    },
    // 搜索表单组件的最终props
    targetSearchFormProps() {
      const {
        searchFormItems = [],
        searchFormProps = {},
        columnsFormItems
      } = this;
      // 默认加上key属性
      searchFormItems.map(item => item.key = item.key || item.dataIndex);
      columnsFormItems.map(item => item.key = item.key || item.dataIndex);
      // _.unionBy 合并数组并基于key去重
      return _.merge({
        items: _.unionBy(searchFormItems, columnsFormItems, 'key')
      }, searchFormProps);
    },
    targetHeaderStyle() {
      return this.bodyPadding === 0 ? Object.assign({}, {
        padding: 0,
        marginBottom: '8px'
      }) : {
        padding: '16px 16px 0 16px'
      };
    },
    targetToolbarStyle() {
      const hasHeader = this.$scopedSlots.layoutHeader || this.targetSearchFormProps.items;
      return this.bodyPadding === 0 ? Object.assign({}, {
        padding: 0,
        marginBottom: '8px'
      }, this.toolbarStyle) : Object.assign({
        paddingTop: hasHeader ? '8px' : 0
      }, this.toolbarStyle);
    },
    // 提供给ColumnSettingPopover组件的原始columns配置
    rawColumns() {
      return this.columns.map(column => {
        // 初始化hideInSetting的值，由于父组件传入的columns不一定有配置该值，初始化后可实现对hideInSetting的响应式处理
        column.hideInSetting = column.hideInSetting === true;
        // 如果没有配置key属性，则把dataIndex或column.scopedSlots.customRender的值赋给key，方便后续用作唯一值
        if (column.key === undefined) column.key = column.dataIndex || column.scopedSlots?.customRender;
        return column;
      });
    }
  },
  watch: {
    pagination: {
      handler(value) {
        this.targetPagination = value === true ? _.cloneDeep(this.defaultPagination) : value;
      },
      immediate: true
    },
    dataSource: {
      handler(val) {
        if (Array.isArray(val) && !this.method) {
          this.init(val);
          // 放在这里，可确保table表格dom元素已渲染，能准确获取元素宽高。只能获取一次
        }
        if (_.isEmpty(this.targetScroll)) this.updateScroll();
      },
      immediate: true
    },
    value: {
      handler(val) {
        if (val !== undefined && !_.isEqual(val, this.selectedRowKeys)) {
          this.selectedRowKeys = val;
        }
      },
      immediate: true
    },
    selectedRowKeys(val) {
      this.$emit('input', val);
    },
    loading: {
      handler(val) {
        this.$emit('update:loading', val);
        this.targetLoading = val;
      },
      immediate: true
    },
    targetLoading: {
      handler(newVal, oldVal) {
        this.$emit('update:loading', newVal);
        if (newVal === false && oldVal === true) this.updateScroll();
      },
      immediate: true
    },
    // 通过 :searchParams.sync="searchParams" 自动同步获取最终的搜索参数
    targetParams: {
      handler(val) {
        this.$emit('update:searchParams', val);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.$nextTick(() => {
      if (!this.showToolBtn) this.targetColumns = this.rawColumns;
      if (!!this.method) {
        this.immediate && this.reload();
      } else {
        this.init(this.dataSource);
      }
    });
  },
  methods: {
    init(rawData) {
      if (!rawData) return;
      this.rawData = rawData;
      let dataSource = _.cloneDeep(rawData);
      if (this.pagination && !Array.isArray(rawData)) {
        const {
          total,
          records
        } = rawData;
        dataSource = _.cloneDeep(records);
        this.targetPagination.total = total;
        this.$emit('update:total', total);
      } else {
        this.$emit('update:total', dataSource.length);
      }
      // 进行数据格式转换
      if (typeof this.transformDataSource === 'function') this.transformDataSource(dataSource);
      this.targetDataSource = dataSource;
      // 可通过 :list.sync="list" 进行调用。适用场景：需要根据list进行某些按钮的禁用或者纯前端修改某一行的数据等
      this.$emit('update:list', dataSource);
    },
    async reload() {
      // 不是通过内部api请求数据时触发reload事件，供父组件用于刷新数据
      if (!this.method) {
        this.$emit('reload', this.targetParams);
        return;
      }
      try {
        if (this.pagination) this.targetPagination.current = 1;
        this.targetLoading = true;
        await this.getDataList();
        this.targetLoading = false;
      } catch (e) {
        this.targetLoading = false;
      }
    },
    handleTableChange(pagination, filters, sorter) {
      const {
        column = {},
        field,
        columnKey,
        order
      } = sorter;
      // column.sorter 排序函数，本地排序使用一个函数(参考 Array.sort 的 compareFunction)，需要服务端排序可设为 true
      // 服务端排序触发重新请求
      if (column.sorter === true || this.sorterCache.order) {
        this.sorterCache = sorter;
        this.sorterParams = column.sorter === true ? {
          sorter: {
            field: columnKey || field,
            order
          }
        } : {};
        this.reload();
      }
      this.$emit('change', pagination, filters, sorter);
    },
    // 获取数据
    async getDataList() {
      try {
        this.targetLoading = true;
        const res = await this.method(this.targetParams);
        this.init(res);
        this.targetLoading = false;
      } catch (e) {
        console.error(e);
        this.targetLoading = false;
      }
    },
    handlePageChange(current, pageSize) {
      const {
        defaultPageSize
      } = this.defaultPagination;
      this.targetPagination.current = current || 1;
      this.targetPagination.pageSize = pageSize || defaultPageSize;

      // 如果rawData为数组，表示接口不分页，全量返回数据。只需进行本地静态分页即可
      if (!Array.isArray(this.rawData)) this.getDataList();

      // 可通过 :curPagination.sync="curPagination" 获取当前的分页信息，实现行内编辑验证等
      // 当前页的某行所在唯一索引号：(curPagination.current - 1) * curPagination.pageSize + index
      this.$emit('update:curPagination', this.targetPagination);
    },
    /**
     * @description: 滚动到data-row-key的值为rowKey的行
     * @param {String} rowKey rowKey属性对应的值，如果有值，则使用该值，否则使用index
     * @param {Number|undefined} index 需要滚动到的行索引号
     * 在父组件通过this.$refs.basisTableLayout.scrollTo(rowKey,index)的方式调用
     */
    scrollTo(rowKey, index = undefined) {
      this.$refs.basisTable.scrollTo(rowKey, index);
    },
    // 更新table的scroll属性
    updateScroll() {
      if (this.scroll === null) {
        this.targetScroll = undefined;
        return;
      }
      // eslint-disable-next-line max-statements
      this.$nextTick(() => {
        // offsetHeight 包括元素高度、内边距和边框，不包括外边距
        const tableDom = document.getElementById(this.tableId);
        const tableHeight = tableDom.offsetHeight || 0;
        const tableWidth = tableDom.offsetWidth;
        const headerDom = document.getElementById(`${this.tableId}-header`) || {};
        const headerHeight = headerDom.offsetHeight || 0;
        const toolbarDom = document.getElementById(`${this.tableId}-toolbar`) || {};
        const toolbarHeight = toolbarDom.offsetHeight || 0;
        const targetBodyHeight = tableHeight - headerHeight - toolbarHeight - 20;

        // table的title插槽高度
        const tableTitleDom = tableDom.getElementsByClassName('ant-table-title')[0] || {};
        const tableTitleHeight = tableTitleDom.offsetHeight || 0;
        // table的footer插槽高度
        const tableFooterDom = tableDom.getElementsByClassName('ant-table-footer')[0] || {};
        const tableFooterHeight = tableFooterDom.offsetHeight || 0;
        // table的表头高度
        const tableHeaderDom = tableDom.getElementsByClassName('ant-table-thead')[0] || {};
        const tableHeaderHeight = tableHeaderDom.offsetHeight || 38;
        // 分页器的高度
        const paginationHeight = this.pagination ? 40 : 0;
        const y = targetBodyHeight - tableTitleHeight - tableHeaderHeight - tableFooterHeight - paginationHeight - this.bodyPadding * 2;
        const targetWidth = tableWidth - this.bodyPadding * 2 - 8;
        this.tableWidth = targetWidth;
        // 合并传入配置
        this.targetScroll = Object.assign({}, {
          x: targetWidth,
          y: y < 200 ? 200 : y
        }, this.scroll);
      });
    },
    // 供外部使用深入调用 BasisTable 的方法 如：this.$refs.basisTableLayout.eventHandler('onSelect', record, selected, selectedRows, nativeEvent)
    eventHandler(event, ...args) {
      this.$refs.basisTable[event](...args);
    }
  }
};